import type { ListTableDivRef } from "../list-table.type";

export const getListTableContentNode = (tableRef: ListTableDivRef) => {
  const wrapper = tableRef.current;
  const node = wrapper?.querySelector(".list-table--table-content");

  return node ? (node as HTMLElement) : node;
};
